'use strict';exports.__esModule = true;var _moment = require('moment/moment');var _moment2 = _interopRequireDefault(_moment);
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _beautifyNumber = require('../../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);
var _ProjectSummary = require('./ProjectSummary.scss');var styles = _interopRequireWildcard(_ProjectSummary);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var currencies = {
  ILS: '₪',
  USD: '$',
  EUR: '€' };


var ProjectSummary = function ProjectSummary(props) {return (
    _react2.default.createElement('div', { className: styles.projectSummary },
      !props.hideLogo && _react2.default.createElement('div', { className: styles.logo },

        _react2.default.createElement('img', { src: props.logo, alt: '' })),

      _react2.default.createElement('div', { className: styles.summary },
        _react2.default.createElement('h1', { className: styles.name }, props.name),
        _react2.default.createElement('h2', { className: styles.shortDescription }, props.shortDescription),
        _react2.default.createElement('div', { className: styles.address },
          _react2.default.createElement('div', null, props.address.street_name, '\xA0', props.address.house_number, ','),
          _react2.default.createElement('div', null, props.address.city_name)),

        _react2.default.createElement('div', { className: styles.about },
          props.price && _react2.default.createElement('div', null, _react2.default.createElement('b', null, props.translate('ProjectDetails', 'price'), ':\xA0'), props.translate('startingFrom'), ' - ', currencies[props.currency] || currencies.ILS, (0, _beautifyNumber2.default)(props.price)),
          props.status && _react2.default.createElement('div', null, _react2.default.createElement('b', null, props.translate('ProjectDetails', 'status'), ':\xA0'), props.status),
          props.completionDate &&
          _react2.default.createElement('div', null,
            _react2.default.createElement('b', null, props.translate('ProjectDetails', 'expectedOccupancy'), ':\xA0'),
            (0, _moment2.default)(props.completionDate).
            locale(props.locale || 'he').
            format('MMMM YYYY')),


          props.propertyTypes && _react2.default.createElement('div', null, _react2.default.createElement('b', null, props.translate('ProjectDetails', 'propertyTypes'), ':\xA0'), props.propertyTypes),
          props.rooms && _react2.default.createElement('div', null, _react2.default.createElement('b', null, props.translate('ProjectDetails', 'rooms'), ':\xA0'), props.rooms)))));};





ProjectSummary.propTypes = {
  translate: _propTypes2.default.func,
  logo: _propTypes2.default.string,
  name: _propTypes2.default.string,
  shortDescription: _propTypes2.default.string,
  address: _propTypes2.default.object,
  price: _propTypes2.default.number,
  status: _propTypes2.default.string,
  completionDate: _propTypes2.default.string,
  propertyTypes: _propTypes2.default.string,
  rooms: _propTypes2.default.string,
  currency: _propTypes2.default.string,
  hideLogo: _propTypes2.default.bool,
  locale: _propTypes2.default.string };exports.default =


ProjectSummary;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectDetailedInfo/ProjectSummary/ProjectSummary.js
// module id = 2817
// module chunks = 0